import Tooltip from "@mui/material/Tooltip";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ASSETS } from "../../../utils/config";
import ProfileMenu from "../../ProfileMenu";
import SearchBar from "../../SearchBar";
import SocialFoxFeedbackForm from "../../SocialFoxFeedbackForm";
import WaitlistFormModal from "../../WaitlistModal";
import {
  Beta,
  FlexContainer,
  Icon,
  IconWrapper,
  LogoContainer,
  MainContainer,
} from "./styles";
import { setIsUserProfile } from "../../../redux/reducers/gallery";
import { useDispatch, useSelector } from "react-redux";
import { getLoggedInUser, isUserLoggedIn } from "../../../utils/helpers";
import { EnterBetaButton } from "../../EnterBetaButton";
import NotificationsNoneIcon from "@mui/icons-material/Notifications";
import { colors } from "../../../utils";
import NotificationDropdown from "../../Notifications/NotificationDropDown";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { toast } from "react-toastify";
import { onMessageListener } from "../../../utils/firebase";
import {
  setNewNotificationTrue,
  addNotification,
  clearNewNotification,
  setNotifications,
} from "../../../redux/reducers/notifications";
import { getNotifications } from "../../../services/api";
import ShareInviteModal from "../../ShareInviteModal";
import { Button } from "@mui/material";

const GalleryHeader = React.forwardRef(
  (
    {
      inviteUrl,
      isUserProfile,
      isJoyrideOpen,
      wheelUpdatedDataSorted,
      isModalOpen,
    },
    ref
  ) => {
    const [openFeedbackModal, setOpenFeedbackModal] = useState(false);
    const [openWaitlistModal, setOpenWaitlistModal] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const profileMenuRef = React.useRef();
    const [inviteShareModalVisible, setInviteShareModalVisible] =
      useState(false);

    const nav = useNavigate();

    const newNotification = useSelector(
      (state) => state.notifications?.newNotification
    );

    const dispatch = useDispatch();

    const isLoggedIn = isUserLoggedIn();

    React.useImperativeHandle(ref, () => ({
      openProfileMenu: () => {
        if (profileMenuRef.current) {
          profileMenuRef.current.toggleDropdown();
        }
      },
      closeProfileMenu: () => {
        if (profileMenuRef.current) {
          profileMenuRef.current.closeDropdown();
        }
      },
    }));

    const handleOpenFeedbackModal = () => {
      setOpenFeedbackModal(true);
    };

    const onInviteclick = () => {
      setInviteShareModalVisible(true);
      // navigator.clipboard
      //   .writeText(inviteUrl)
      //   .then(() => {
      //     toast.success('Presentation Form Link copied to Clipboard');
      //   })
      //   .catch((err) => {
      //     console.error('Failed to copy Presentation Form Link: ', err);
      //   });
    };

    const handleNotificationsClick = () => {
      setShowDropdown(!showDropdown);
      if (newNotification) {
        dispatch(clearNewNotification());
      }
    };

    const fetchNotifications = async (page = 1) => {
      try {
        const response = await getNotifications(page);
        const newNotifications = response.data.results;
        dispatch(setNotifications(newNotifications));
      } catch (err) {
        console.error("Failed to fetch notifications:", err);
      } finally {
        // setLoading(false);
      }
    };

    useEffect(() => {
      fetchNotifications(1);
    }, []);

    return (
      <MainContainer>
        <FlexContainer>
          <LogoContainer
            onClick={() => {
              if (isLoggedIn) {
                nav(`/gallery/${getLoggedInUser().id}`);
                dispatch(setIsUserProfile(true));
              } else {
                nav("/login"); // Navigate to login if not logged in
              }
            }}
          >
            <img src={ASSETS.iyugaBetaLogo} height={40} width={40} />
          </LogoContainer>
          {isLoggedIn && <SearchBar />}
        </FlexContainer>
        {/* <CenterContainer>
        <AddWheelButton>
          <a href="/builder">
            <img
              src={ASSETS.segmentEditor.AddWheel}
              height={60}
              width={60}
              alt="Add Wheel"
            />
          </a>
        </AddWheelButton>
      </CenterContainer> */}
        <FlexContainer>
          {isLoggedIn ? (
            <>
              {/* <IconWrapper>
          <Icon src={ASSETS.segmentEditor.NotificationIcon} />
        </IconWrapper> */}
              <Tooltip title="Give Feedback">
                <div
                  style={{
                    flexDirection: "row",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <IconWrapper className="feedback-button">
                    <Icon
                      src={ASSETS.feedback2}
                      onClick={handleOpenFeedbackModal}
                    />
                  </IconWrapper>
                </div>
              </Tooltip>
              {/* {newNotification ? (
            <FiberManualRecordIcon
              style={{
                color: "orange",
                fontSize: "14px",
                marginRight: "-27px",
                marginTop: "-15px",
                zIndex: 1000,
              }}
            />
          ) : null}
          <NotificationsNoneIcon
            onClick={handleNotificationsClick}
            style={{
              cursor: "pointer",
              color: colors.PrimaryPurple,
              marginRight: "10px",
              fontSize: "30px",
            }}
          /> */}
              {showDropdown && (
                <NotificationDropdown onClose={() => setShowDropdown(false)} />
              )}
              <div style={{ display: "flex", alignItems: "center" }}>
                {/* {!!sessionStorage.getItem('referralData') && ( */}
                {isUserProfile && (
                  <EnterBetaButton
                    onClickBeta={onInviteclick}
                    onlyInvite={true}
                  />
                )}
                <ProfileMenu
                  ref={profileMenuRef}
                  className="profile-menu"
                  isJoyrideOpen={isJoyrideOpen}
                  wheelUpdatedDataSorted={wheelUpdatedDataSorted}
                  isModalOpen={isModalOpen}
                />
              </div>
            </>
          ) : (
            <Button
              variant="contained"
              onClick={() => nav("/login")}
              sx={{
                height: 32,
                borderRadius: "8px",
                opacity: 1,
                gap: "8px",
                padding: "6px 10px",
                background: "#8F38EF",
                boxShadow:
                  "0px 2px 5px 0px #B6CD261A, 0px 0px 0px 1px #7A18E6, 0px 1px 1px 0px #00000024, 0px 1px 0px 0px #C590FF inset",
                "&:hover": {
                  background: "#8F38EF", // Keep the same background on hover
                },
              }}
            >
              Login Or Signup
            </Button>
          )}

          <ShareInviteModal
            isVisible={inviteShareModalVisible}
            onClose={() => setInviteShareModalVisible(false)}
          />
          <SocialFoxFeedbackForm
            open={openFeedbackModal}
            onClose={() => {
              setOpenFeedbackModal(false);
            }}
          />
        </FlexContainer>
        <WaitlistFormModal
          open={openWaitlistModal}
          onClose={() => setOpenWaitlistModal(false)}
        />
      </MainContainer>
    );
  }
);

export default GalleryHeader;
